import * as React from "react";
import { forwardRef } from "react";
const SvgDrop = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20 14.9856C20 19.4039 16.4183 22.9856 12 22.9856C7.58172 22.9856 4 19.4039 4 14.9856C4 13.9247 4.20651 12.912 4.58152 11.9856C5.76829 9.05377 12 2.9856 12 2.9856C12 2.9856 18.2317 9.05377 19.4185 11.9856C19.7935 12.912 20 13.9247 20 14.9856Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDrop);
export default ForwardRef;
